import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'referredCandidates';
const initialState = {
  searchTerm: null,
  filters: {
    status: [],
    department: [],
    kind: [],
    isFilterApplied: false,
  },
  reloadConfig: {},
  status: [],
  department: [],
  kind: [],
  isFilterApplied: false,
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Refered on (Newest to oldest)',
    value: 'desc',
    element: 'created_at',
    order: 'desc',
  },
  referredCandidateList: {
    isLoading: true,
    data: {},
    status: undefined,
    error: undefined,
    meta: {},
  },
  filterWithValues: [],
};

const { reducer, actions: referredCandidatesActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    resetSortToInitial: (state) => {
      state.sort = initialState?.sort;
    },

    setReloadConfig: (state, { payload: { value } }) => {
      state.reloadConfig = value;
    },

    applyFilter: (state, { payload, ...props }) => {
      const { key, value } = payload;
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    setFiltersData: (state, { payload }) => {
      state.filterWithValues = payload;
    },

    applyReferalFilter: (state, { payload }) => {
      state.filters = payload?.beConfig;
      state.page = { ...initialState.page };
    },

    applyTopTalent: (state) => {
      state.filters.top_talent = !state.filters.top_talent;
      state.page = { ...initialState.page };
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
      }
    },

    setApiData: (state, { payload }) => {
      const { key, data, meta, status, error, isLoading } = payload || {};
      if (state[key]) {
        state[key].data = data;
        state[key].meta = meta;
        state[key].isLoading = isLoading;
        state[key].status = status;
        if (error) {
          state[key].error = error;
        }
      }
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
      state.filters.isFilterApplied = false;
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },
  },
});

export { referredCandidatesActions };
export default reducer;
